/**
 * The left edge's shared column -- layout, not a feature, so it owns no ids
 * but its own (leftstack.css says why it is one flex column).  happy.js and
 * hud.js mount their panels INTO the element this returns, in ui/index.js's
 * order: the happiness panel first, then the dev cat-switcher under it.
 */
import "./leftstack.css";
import { mount } from "./dom.js";

export function mountLeftStack() {
  return mount(`<div id="left-stack"></div>`);
}
